import { useTour } from '../../core/hooks/useTour.js';
import { getMenuSteps } from '../../core/utils/tour.js';
import { useRef, useEffect } from 'react';

const useMenuTour = (setOnboardingShowed, showOnboarding) => {
  const {
    setIsOpen,
    setSteps
  } = useTour();
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && showOnboarding) {
      setSteps(getMenuSteps(ref, setOnboardingShowed));
      setTimeout(() => setIsOpen(true), 1e3);
    }
  }, [ref, setSteps, showOnboarding, setIsOpen, setOnboardingShowed]);
  return ref;
};

export { useMenuTour };
